import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import infoIcon from "../assets/images/infobtnblue.svg";
import searchicon from "../assets/images/searchicon.svg";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import { commonservices } from "../services/CommonServices";
import { RoleGetList } from "../services/ReduxTookit/Slice/RoleRedux";
import {
  SubscribersContactGetByPrimaryKey,
  SubscribersContactSave,
} from "../services/ReduxTookit/Slice/SubscribersContactRedux";
import useDebounce from "../hooks/useDebounce";
import { GetUserListBySearch } from "../services/ReduxTookit/Slice/UserRedux";
import { toast } from "react-toastify";
import { SubscriberInviteUser } from "../services/ReduxTookit/Slice/SubscribersRedux";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const InviteSubscriberModal = (props) => {
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);
  const DevRoute = window.location.href.includes(
    `${process.env.REACT_APP_DEV}`
  );

  const [Loading, setLoading] = useState(false);
  const [FindEmail, setFindEmail] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [SearchValueList, setSearchValueList] = useState([]);
  const [ContactDetailLoading, setContactDetailLoading] = useState(false);
  const ProfileImgref = useRef();
  const [SearchUserValue, setSearchUserValue] = useState("");
  const [file, setFile] = useState();
  // const debouncingValue = useDebounce(SearchUserValue >= 6, 500);
  const [roleType, setRoleType] = useState(null);

  const dispatch = useDispatch();
  const [input, setInput] = useState({
    userid: "",
    email: "",
    callfrom: "",
    // roleid: "",
    roleid: DevRoute ? 7 : "",
    errors: {
      email: "",
      roleid: "",
      ValidationRules: [
        {
          FieldName: "email",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "email",
          ValidationType: "email",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "roleid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  async function getContactDetail() {
    setContactDetailLoading(true);
    dispatch(
      SubscribersContactGetByPrimaryKey(
        props?.selectedcontact?.subscriberscontactid
      )
    )?.then((response) => {
      setContactDetailLoading(false);
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data) {
          setInput({
            ...input,
            subscriberscontactid: response?.payload?.data?.data
              ?.subscriberscontactid
              ? response?.payload?.data?.data?.subscriberscontactid
              : "",
            firstname: response?.payload?.data?.data?.firstname
              ? response?.payload?.data?.data?.firstname
              : "",
            lastname: response?.payload?.data?.data?.lastname
              ? response?.payload?.data?.data?.lastname
              : "",
            email: response?.payload?.data?.data?.email
              ? response?.payload?.data?.data?.email
              : "",
            contactno: response?.payload?.data?.data?.contactno
              ? response?.payload?.data?.data?.contactno
              : "",
            address: response?.payload?.data?.data?.address
              ? response?.payload?.data?.data?.address
              : "",
            city: response?.payload?.data?.data?.city
              ? response?.payload?.data?.data?.city
              : "",
            state: response?.payload?.data?.data?.state
              ? response?.payload?.data?.data?.state
              : "",
            country: response?.payload?.data?.data?.country
              ? response?.payload?.data?.data?.country
              : "",
            zipcode: response?.payload?.data?.data?.zipcode
              ? response?.payload?.data?.data?.zipcode
              : "",
            photofile: response?.payload?.data?.data?.photourl
              ? response?.payload?.data?.data?.photourl
              : "",
            roleid: response?.payload?.data?.data?.roleid
              ? response?.payload?.data?.data?.roleid
              : "",
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  const getRoleByType = async () => {
    dispatch(RoleGetList())?.then((res) => {
      if (res?.payload?.isValidate) {
        setRoleType(res?.payload?.data?.data);
      }
      if (!res?.payload?.isValidate) {
        setRoleType(null);
      }
    });
  };
  useEffect(() => {
    getRoleByType();
  }, []);
  // useEffect(() => {
  //   if (props?.type === "Update") {
  //     getContactDetail();
  //   }
  // }, [props?.type]);
  const fnInputChange = (value, tag) => {
    setInput({
      ...input,
      [tag]: value,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        userid: input.userid,
        callfrom: DevRoute ? "Developer" : "DataFactory",
        email: input?.email,
        roleid: input?.roleid,
      };

      dispatch(SubscriberInviteUser(body))?.then((response) => {
        setLoading(false);
        if (response?.payload?.isValidate) {
          props.onHide();
          props.bindlist();
        }

        if (!response?.payload?.isValidate) {
        }
      });
    }
  };
  async function fngetUserListBySearch(text) {
    setContactDetailLoading(true);
    let body = {
      searchtext: text,
    };
    dispatch(GetUserListBySearch(body))?.then((response) => {
      setContactDetailLoading(false);
      if (response?.payload?.isValidate) {
        setSearchValueList(response?.payload?.data?.data?.dataList1);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event?.preventDefault();
        handleSubmit(event);
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  });
  useEffect(() => {
    if (SearchUserValue?.length >= 6) {
      fngetUserListBySearch(SearchUserValue);
    } else {
      setFindEmail("");
    }
  }, [SearchUserValue]);
  const fnHandleFind = () => {
    if (SearchUserValue) {
      let findvalue = SearchValueList?.find(
        (f) => f.username === SearchUserValue
      );
      if (findvalue) {
        setInput({
          ...input,
          userid: findvalue?.userid,
          email: findvalue?.username,
        });
        setFindEmail(findvalue);
        toast.success("User found.");
      } else {
        setFindEmail("");
        setInput({
          ...input,
          email: "",
          userid: "",
        });
        toast.error("User Not found.");
      }
    } else {
      toast.error("Please add some Value.");
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="invite-subscriber"
      backdrop="static"
    >
      {Loading && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.type} Invite Subscriber
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <Modal.Body>
          <div className="invite-subscriber-note">
            <p>Invite trusted contacts to collaborate on your workflow. Assign roles for monitoring, managing tasks, and receiving updates, ensuring smooth teamwork and transparent visibility throughout your workflow's execution and progress.</p>
            <p style={{ color: "red" }}>
              <b>Note:</b> Only registered users can be invited. Please ensure
              the user is registered before sending an invitation.
            </p>
          </div>
          {!showSearch && (            
              <div className="header-search-input searchplaceholder">
                <div className="invite-search position-relative">
                  <div
                    className={`${input.errors.email && "error-border-line"}`}
                  >
                    <InputGroup className="w-100">
                      <InputGroup.Text id="basic-addon1">
                        <img
                          src={searchicon}
                          alt="searchicon"
                          // onClick={handleshowSearch}
                          className="cursor-pointer"
                        />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Search User"
                        // aria-label="Search"
                        aria-describedby="basic-addon1"
                        value={SearchUserValue}
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchUserValue(e.target.value);
                          fnInputChange(e?.target?.value, "email");
                        }}
                      />
                      <Button
                        onClick={() => fnHandleFind()}
                        className="blue-btn w-auto"
                      >
                        Find
                      </Button>
                    </InputGroup>
                  </div>
                  {input.errors.email && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={input.errors.email}
                        />
                      </span>
                    </p>
                  )}
                </div>
                {FindEmail && (
                  <div
                    className="invited-user p-1"
                    onClick={() => setShowSearch(true)}
                  >
                    <p>{FindEmail?.displayname}</p>
                  </div>
                )}
              </div>            
          )}
          <>
            {FindEmail && (
              <Row className="mt-1 subscriber-select-data">
                {/* <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">
                      User List
                      <span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Select
                        className="common-select contact-dropdown-size m-0"
                        value={input.email}
                        onChange={(e) => {
                          fnInputChange(
                            // e?.target?.value ? parseInt(e?.target?.value) : "",
                            e?.target?.value,
                            "email"
                          );
                        }}
                        isInvalid={input?.errors?.email}
                      >
                        <option value="">Select User</option>
                        {SearchValueList?.map((item) => {
                          return (
                            <option value={item?.username}>
                              {item?.username}
                            </option>
                          );
                        })}
                      </Form.Select>
                      {input.errors.email && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.email}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col> */}
                {showSearch && (
                  <Col md={12}>
                    {DevRoute ? (
                      // <Form.Group className="form-group mb-3">
                      //   <Form.Label className="login-label">
                      //     Devloper Role
                      //     <span className="ms-1 red-color-text">*</span>
                      //   </Form.Label>
                      //   <div className="position-relative">
                      //     <Form.Select
                      //       disabled
                      //       className="common-select contact-dropdown-size m-0"
                      //       value={input.roleid}
                      //     >
                      //       <option value={7}>Contact</option>
                      //     </Form.Select>
                      //   </div>
                      // </Form.Group>
                      <>
                        <div className="selected-user-box">
                          <h6>Selected Subscriber : </h6>
                          <p> {FindEmail?.displayname}</p>
                        </div>

                        <Form.Group className="form-group mb-3">
                          <Form.Label className="login-label">
                            Devloper Role
                            <span className="ms-1 red-color-text">*</span>
                          </Form.Label>
                          <div>
                            <Form.Check
                              key={7}
                              type="radio"
                              id={`role-7`}
                              label={"Contact"}
                              name="workflowRole"
                              value={7}
                              checked
                              // onChange={(e) =>
                              //   fnInputChange(
                              //     parseInt(e.target.value),
                              //     "roleid"
                              //   )
                              // }
                              isInvalid={!!input?.errors?.roleid}
                              className="mb-2"
                            />

                            {/* {input.errors.roleid && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="d-block"
                            >
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.roleid}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )} */}
                          </div>
                        </Form.Group>
                        {input.errors.roleid && (
                          <p className="invite-subscriber-error-box">
                            {input.errors.roleid}
                          </p>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="selected-user-box">
                          <h6>Selected Subscriber : </h6>
                          <p> {FindEmail?.displayname}</p>
                        </div>

                        <Form.Group className="form-group mb-3">
                          <Form.Label className="login-label">
                            Workflow Role
                            <span className="ms-1 red-color-text">*</span>
                          </Form.Label>
                          <div>
                            {roleType?.dataList1?.map((item) => (
                              <div className="invite-subscriber-role-list">
                                <Form.Check
                                  key={item?.roleid}
                                  type="radio"
                                  id={`role-${item?.roleid}`}
                                  // label={item?.rolename}
                                  name="workflowRole"
                                  value={item?.roleid}
                                  checked={
                                    parseInt(input.roleid) === item?.roleid
                                  }
                                  onChange={(e) =>
                                    fnInputChange(
                                      parseInt(e.target.value),
                                      "roleid"
                                    )
                                  }
                                  isInvalid={!!input?.errors?.roleid}
                                  className="mb-2"
                                />
                                <label htmlFor={`role-${item?.roleid}`}>
                                  {item?.rolename}
                                  <span>{item?.details}</span>
                                </label>
                              </div>
                            ))}

                            {/* {input.errors.roleid && (
                              <Form.Control.Feedback
                                type="invalid"
                                className="d-block"
                              >
                                <span className="error-message-icon">
                                  <img
                                    src={infoIcon}
                                    alt="infoIcon"
                                    title={input.errors.roleid}
                                  />
                                </span>
                              </Form.Control.Feedback>
                            )} */}
                          </div>
                        </Form.Group>
                        {input.errors.roleid && (
                          <p className="invite-subscriber-error-box">
                            {input.errors.roleid}
                          </p>
                        )}
                      </>
                      // <Form.Group className="form-group mb-3">
                      //   <Form.Label className="login-label">
                      //     Workflow Role
                      //     <span className="ms-1 red-color-text">*</span>
                      //   </Form.Label>
                      //   <div className="position-relative">
                      //     <Form.Select
                      //       className="common-select contact-dropdown-size m-0"
                      //       value={input.roleid}
                      //       onChange={(e) => {
                      //         fnInputChange(
                      //           e?.target?.value
                      //             ? parseInt(e?.target?.value)
                      //             : "",
                      //           "roleid"
                      //         );
                      //       }}
                      //       isInvalid={input?.errors?.roleid}
                      //     >
                      //       <option value="">Select Role</option>
                      //       {roleType?.dataList1?.map((item) => {
                      //         return (
                      //           <option value={item?.roleid}>
                      //             {item?.rolename}
                      //           </option>
                      //         );
                      //       })}
                      //     </Form.Select>
                      //     {input.errors.roleid && (
                      //       <Form.Control.Feedback type="invalid">
                      //         <span className="error-message-icon">
                      //           <img
                      //             src={infoIcon}
                      //             alt="infoIcon"
                      //             title={input.errors.roleid}
                      //           />
                      //         </span>
                      //       </Form.Control.Feedback>
                      //     )}
                      //   </div>
                      // </Form.Group>
                    )}
                  </Col>
                )}
              </Row>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          {showSearch && (
            <button
              className="grey-btn w-auto"
              onClick={() => {
                setShowSearch(false);
                setSearchUserValue("");
              }}
            >
              Cancel
            </button>
          )}
          <button disabled={Loading} className="blue-btn w-auto" type="submit">
            {Loading ? <SubmitLoading /> : "Submit"}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default InviteSubscriberModal;
